import { tuple } from '../_util/type';
const ColumnFixedPlacements = tuple('left', 'right');
